import { Accordion } from '@mantine/core';
import classNames from 'theme/components/DataDisplay/Accordion/Accordion.module.css';

export default Accordion.extend({
  classNames,
});
